//@ts-check
var getLocalName = function getLocalName(name) {
  var nsEndIndex = name.indexOf(':');
  if (nsEndIndex !== -1) name = name.substring(nsEndIndex + 1);
  return name;
};

var getAttributeNode = function getAttributeNode(attribute, parentXpath) {
  return {
    name: getLocalName(attribute.name),
    xpath: parentXpath + '/@' + attribute.name,
    type: 'field'
  };
};

var getElementNode = function getElementNode(element) {
  var parentXpath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var xpath = parentXpath + '/' + element.name;
  var attributes = (element.attributes || []).map(function (attribute) {
    return getAttributeNode(attribute, xpath);
  });
  var elements = (element.elements || []).map(function (element) {
    return getElementNode(element, xpath);
  });
  return {
    name: getLocalName(element.name),
    type: 'element',
    uuid: element.uuid,
    xpath: xpath,
    collectionType: element.collectionType,
    isTextOnly: element.isTextOnly,
    children: attributes.concat(elements)
  };
};

export default getElementNode;